<template>
    <div class="c-overview-summary component">
        <span class="text--gray">Dokonano następującego wyboru</span>
        <br>
        <div class="mb--1 mt--1" v-if="getSelectedDealer">
            <img src="@/assets/localizations.jpg" alt="Localization" class="c-overview-summary__icon">
            <h3 class="c-overview-summary__dealerName">{{ getSelectedDealer.name }}</h3>
            Doradca serwisowy: {{ getAvaibleTerms[lead.term_key].user_name }}
        </div>
        <div class="mb--5 mt--1">
            <span>Zaplanowane przyjęcie w dniu {{ getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(lead.date)] }} {{ lead.date }}, o godzinie, {{lead.hour}}.</span>
            <br>
            <span>Zaplanowane zakończenie naprawy  w dniu {{ getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(lead.repair.date)] }}, {{ lead.repair.date }}  o godz. {{ getEndDate.getHours() }}:{{ getEndDate.getMinutes() }}</span>
        </div>
        <div class="mb--5 mt--1" v-if="lead.replacement_car_id != null">
            Mobilność: {{ getReplacementCars.filter(e => e.id == lead.replacement_car_id? e.model : false ).map(e => e.brand+' '+e.model)[0] }}
        </div>
        <span class="text--gray">Usługi do wykonania:</span>
        <div class="flex-col--5 mt--1 mb--2">
            <div v-for="service in getServices.filter(e => lead.services_val.includes(e.val) )" class="flex-row c-overview-summary__service">
                <div class="flex-col--1">
                    <img :src="service.icon" :alt="service.name" class="c-services__icon">
                </div>
                <div class="flex-col--9">
                    <strong>{{service.name}}</strong>
                    <br>
                    {{ service.text }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions,mapGetters} from 'vuex';
    import {getDate,getDateWithBufor} from '../../helpers/date.js'
    import lead from '../../mixins/lead.js';
    export default{
        mixins:[lead],
        computed:{
            ...mapGetters({
                getDealers:'definitions/getDealers',
                getModels:'definitions/getModels',
                getAvaibleTerms:'definitions/getAvaibleTerms',
                getDetepickerConfig:'definitions/getDetepickerConfig',
                getReplacementCars: 'definitions/getReplacementCars',
                getServices: 'definitions/getServices'
            }),
            getSelectedDealer() { return this.getDealers.find( e => e.id == this.lead.dealer_id) },
            getEndDate() {
                return getDateWithBufor(getDate(this.lead.repair),120)
            }
        }
    }
</script>
<style lang="scss">
    .c-overview-summary{
        font-size: 1.25rem;
        &__icon{
            width: 24px;
            float:left;
            margin-right: .25rem;
        }
        &__dealerName{
        }
        &__service{
            font-size: 1rem;
        }
    }
</style>